"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _abbasanta = _interopRequireDefault(require("./16_group_2022_12_12/abbasanta"));

var _abriola = _interopRequireDefault(require("./16_group_2022_12_12/abriola"));

var _acquafondata = _interopRequireDefault(require("./16_group_2022_12_12/acquafondata"));

var _acquaro = _interopRequireDefault(require("./16_group_2022_12_12/acquaro"));

var _altavillaIrpina = _interopRequireDefault(require("./16_group_2022_12_12/altavilla-irpina"));

var _andreis = _interopRequireDefault(require("./16_group_2022_12_12/andreis"));

var _anzanoDiPuglia = _interopRequireDefault(require("./16_group_2022_12_12/anzano-di-puglia"));

var _anzolaDellEmilia = _interopRequireDefault(require("./16_group_2022_12_12/anzola-dell-emilia"));

var _auletta = _interopRequireDefault(require("./16_group_2022_12_12/auletta"));

var _barcis = _interopRequireDefault(require("./16_group_2022_12_12/barcis"));

var _biccari = _interopRequireDefault(require("./16_group_2022_12_12/biccari"));

var _borgoSanGiovanni = _interopRequireDefault(require("./16_group_2022_12_12/borgo-san-giovanni"));

var _borriana = _interopRequireDefault(require("./16_group_2022_12_12/borriana"));

var _callabiana = _interopRequireDefault(require("./16_group_2022_12_12/callabiana"));

var _calvignasco = _interopRequireDefault(require("./16_group_2022_12_12/calvignasco"));

var _camburzano = _interopRequireDefault(require("./16_group_2022_12_12/camburzano"));

var _capestrano = _interopRequireDefault(require("./16_group_2022_12_12/capestrano"));

var _capistrello = _interopRequireDefault(require("./16_group_2022_12_12/capistrello"));

var _carenno = _interopRequireDefault(require("./16_group_2022_12_12/carenno"));

var _carlopoli = _interopRequireDefault(require("./16_group_2022_12_12/carlopoli"));

var _carpinetoDellaNora = _interopRequireDefault(require("./16_group_2022_12_12/carpineto-della-nora"));

var _casalvieri = _interopRequireDefault(require("./16_group_2022_12_12/casalvieri"));

var _caselleLurani = _interopRequireDefault(require("./16_group_2022_12_12/caselle-lurani"));

var _casalmaggiore = _interopRequireDefault(require("./16_group_2022_12_12/casalmaggiore"));

var _cassinaValsassina = _interopRequireDefault(require("./16_group_2022_12_12/cassina-valsassina"));

var _castelnuovoBoccaDAdda = _interopRequireDefault(require("./16_group_2022_12_12/castelnuovo-bocca-d-adda"));

var _castiglioneDOrcia = _interopRequireDefault(require("./16_group_2022_12_12/castiglione-d-orcia"));

var _castiragaVidardo = _interopRequireDefault(require("./16_group_2022_12_12/castiraga-vidardo"));

var _cautano = _interopRequireDefault(require("./16_group_2022_12_12/cautano"));

var _cellaDati = _interopRequireDefault(require("./16_group_2022_12_12/cella-dati"));

var _cerretoSannita = _interopRequireDefault(require("./16_group_2022_12_12/cerreto-sannita"));

var _ciro = _interopRequireDefault(require("./16_group_2022_12_12/ciro"));

var _copparo = _interopRequireDefault(require("./16_group_2022_12_12/copparo"));

var _cortino = _interopRequireDefault(require("./16_group_2022_12_12/cortino"));

var _crespiatica = _interopRequireDefault(require("./16_group_2022_12_12/crespiatica"));

var _crevacuore = _interopRequireDefault(require("./16_group_2022_12_12/crevacuore"));

var _crognaleto = _interopRequireDefault(require("./16_group_2022_12_12/crognaleto"));

var _crosia = _interopRequireDefault(require("./16_group_2022_12_12/crosia"));

var _dragoni = _interopRequireDefault(require("./16_group_2022_12_12/dragoni"));

var _esinoLario = _interopRequireDefault(require("./16_group_2022_12_12/esino-lario"));

var _filandari = _interopRequireDefault(require("./16_group_2022_12_12/filandari"));

var _filignano = _interopRequireDefault(require("./16_group_2022_12_12/filignano"));

var _firenze = _interopRequireDefault(require("./16_group_2022_12_12/firenze"));

var _fossatoSerralta = _interopRequireDefault(require("./16_group_2022_12_12/fossato-serralta"));

var _garaguso = _interopRequireDefault(require("./16_group_2022_12_12/garaguso"));

var _gemonaDelFriuli = _interopRequireDefault(require("./16_group_2022_12_12/gemona-del-friuli"));

var _ghedi = _interopRequireDefault(require("./16_group_2022_12_12/ghedi"));

var _ghilarza = _interopRequireDefault(require("./16_group_2022_12_12/ghilarza"));

var _gimigliano = _interopRequireDefault(require("./16_group_2022_12_12/gimigliano"));

var _gioiaDeiMarsi = _interopRequireDefault(require("./16_group_2022_12_12/gioia-dei-marsi"));

var _graffignana = _interopRequireDefault(require("./16_group_2022_12_12/graffignana"));

var _grottolella = _interopRequireDefault(require("./16_group_2022_12_12/grottolella"));

var _gualdo = _interopRequireDefault(require("./16_group_2022_12_12/gualdo"));

var _guidoniaMontecelio = _interopRequireDefault(require("./16_group_2022_12_12/guidonia-montecelio"));

var _introdacqua = _interopRequireDefault(require("./16_group_2022_12_12/introdacqua"));

var _ionadi = _interopRequireDefault(require("./16_group_2022_12_12/ionadi"));

var _laurino = _interopRequireDefault(require("./16_group_2022_12_12/laurino"));

var _lessona = _interopRequireDefault(require("./16_group_2022_12_12/lessona"));

var _limatola = _interopRequireDefault(require("./16_group_2022_12_12/limatola"));

var _limbadi = _interopRequireDefault(require("./16_group_2022_12_12/limbadi"));

var _livraga = _interopRequireDefault(require("./16_group_2022_12_12/livraga"));

var _magnacavallo = _interopRequireDefault(require("./16_group_2022_12_12/magnacavallo"));

var _martirano = _interopRequireDefault(require("./16_group_2022_12_12/martirano"));

var _masainas = _interopRequireDefault(require("./16_group_2022_12_12/masainas"));

var _masserano = _interopRequireDefault(require("./16_group_2022_12_12/masserano"));

var _mercogliano = _interopRequireDefault(require("./16_group_2022_12_12/mercogliano"));

var _mompeo = _interopRequireDefault(require("./16_group_2022_12_12/mompeo"));

var _montagnareale = _interopRequireDefault(require("./16_group_2022_12_12/montagnareale"));

var _monteMarenzo = _interopRequireDefault(require("./16_group_2022_12_12/monte-marenzo"));

var _monteodorisio = _interopRequireDefault(require("./16_group_2022_12_12/monteodorisio"));

var _montichiari = _interopRequireDefault(require("./16_group_2022_12_12/montichiari"));

var _mulazzano = _interopRequireDefault(require("./16_group_2022_12_12/mulazzano"));

var _narcao = _interopRequireDefault(require("./16_group_2022_12_12/narcao"));

var _nettuno = _interopRequireDefault(require("./16_group_2022_12_12/nettuno"));

var _norbello = _interopRequireDefault(require("./16_group_2022_12_12/norbello"));

var _ofena = _interopRequireDefault(require("./16_group_2022_12_12/ofena"));

var _olginate = _interopRequireDefault(require("./16_group_2022_12_12/olginate"));

var _orioLitta = _interopRequireDefault(require("./16_group_2022_12_12/orio-litta"));

var _ospedalettoLodigiano = _interopRequireDefault(require("./16_group_2022_12_12/ospedaletto-lodigiano"));

var _padru = _interopRequireDefault(require("./16_group_2022_12_12/padru"));

var _pagoDelValloDiLauro = _interopRequireDefault(require("./16_group_2022_12_12/pago-del-vallo-di-lauro"));

var _parenti = _interopRequireDefault(require("./16_group_2022_12_12/parenti"));

var _patti = _interopRequireDefault(require("./16_group_2022_12_12/patti"));

var _pella = _interopRequireDefault(require("./16_group_2022_12_12/pella"));

var _pescina = _interopRequireDefault(require("./16_group_2022_12_12/pescina"));

var _positano = _interopRequireDefault(require("./16_group_2022_12_12/positano"));

var _premia = _interopRequireDefault(require("./16_group_2022_12_12/premia"));

var _re = _interopRequireDefault(require("./16_group_2022_12_12/re"));

var _renon = _interopRequireDefault(require("./16_group_2022_12_12/renon"));

var _roccalumera = _interopRequireDefault(require("./16_group_2022_12_12/roccalumera"));

var _roccamorice = _interopRequireDefault(require("./16_group_2022_12_12/roccamorice"));

var _rofrano = _interopRequireDefault(require("./16_group_2022_12_12/rofrano"));

var _rombiolo = _interopRequireDefault(require("./16_group_2022_12_12/rombiolo"));

var _sagronMis = _interopRequireDefault(require("./16_group_2022_12_12/sagron-mis"));

var _salaBiellese = _interopRequireDefault(require("./16_group_2022_12_12/sala-biellese"));

var _saleranoSulLambro = _interopRequireDefault(require("./16_group_2022_12_12/salerano-sul-lambro"));

var _sanCalogero = _interopRequireDefault(require("./16_group_2022_12_12/san-calogero"));

var _sanGiorgioAlbanese = _interopRequireDefault(require("./16_group_2022_12_12/san-giorgio-albanese"));

var _sanGiorgioDellaRichinvelda = _interopRequireDefault(require("./16_group_2022_12_12/san-giorgio-della-richinvelda"));

var _sanMartinoSannita = _interopRequireDefault(require("./16_group_2022_12_12/san-martino-sannita"));

var _sanPietroInAmantea = _interopRequireDefault(require("./16_group_2022_12_12/san-pietro-in-amantea"));

var _sanRoberto = _interopRequireDefault(require("./16_group_2022_12_12/san-roberto"));

var _saponara = _interopRequireDefault(require("./16_group_2022_12_12/saponara"));

var _scampitella = _interopRequireDefault(require("./16_group_2022_12_12/scampitella"));

var _sessanoDelMolise = _interopRequireDefault(require("./16_group_2022_12_12/sessano-del-molise"));

var _spinete = _interopRequireDefault(require("./16_group_2022_12_12/spinete"));

var _stio = _interopRequireDefault(require("./16_group_2022_12_12/stio"));

var _tavigliano = _interopRequireDefault(require("./16_group_2022_12_12/tavigliano"));

var _tergu = _interopRequireDefault(require("./16_group_2022_12_12/tergu"));

var _torino = _interopRequireDefault(require("./16_group_2022_12_12/torino"));

var _torraca = _interopRequireDefault(require("./16_group_2022_12_12/torraca"));

var _tramontiDiSopra = _interopRequireDefault(require("./16_group_2022_12_12/tramonti-di-sopra"));

var _tramontiDiSotto = _interopRequireDefault(require("./16_group_2022_12_12/tramonti-di-sotto"));

var _travesio = _interopRequireDefault(require("./16_group_2022_12_12/travesio"));

var _trontano = _interopRequireDefault(require("./16_group_2022_12_12/trontano"));

var _tufo = _interopRequireDefault(require("./16_group_2022_12_12/tufo"));

var _turrivalignani = _interopRequireDefault(require("./16_group_2022_12_12/turrivalignani"));

var _valBrembilla = _interopRequireDefault(require("./16_group_2022_12_12/val-brembilla"));

var _valmozzola = _interopRequireDefault(require("./16_group_2022_12_12/valmozzola"));

var _valtorta = _interopRequireDefault(require("./16_group_2022_12_12/valtorta"));

var _valvasoneArzene = _interopRequireDefault(require("./16_group_2022_12_12/valvasone-arzene"));

var _villaDelBosco = _interopRequireDefault(require("./16_group_2022_12_12/villa-del-bosco"));

var _villandro = _interopRequireDefault(require("./16_group_2022_12_12/villandro"));

var _villapiana = _interopRequireDefault(require("./16_group_2022_12_12/villapiana"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _abbasanta["default"], {}, _abriola["default"], {}, _acquafondata["default"], {}, _acquaro["default"], {}, _altavillaIrpina["default"], {}, _andreis["default"], {}, _anzanoDiPuglia["default"], {}, _anzolaDellEmilia["default"], {}, _auletta["default"], {}, _barcis["default"], {}, _biccari["default"], {}, _borgoSanGiovanni["default"], {}, _borriana["default"], {}, _callabiana["default"], {}, _calvignasco["default"], {}, _camburzano["default"], {}, _capestrano["default"], {}, _capistrello["default"], {}, _carenno["default"], {}, _carlopoli["default"], {}, _carpinetoDellaNora["default"], {}, _casalvieri["default"], {}, _caselleLurani["default"], {}, _casalmaggiore["default"], {}, _cassinaValsassina["default"], {}, _castelnuovoBoccaDAdda["default"], {}, _castiglioneDOrcia["default"], {}, _castiragaVidardo["default"], {}, _cautano["default"], {}, _cellaDati["default"], {}, _cerretoSannita["default"], {}, _ciro["default"], {}, _copparo["default"], {}, _cortino["default"], {}, _crespiatica["default"], {}, _crevacuore["default"], {}, _crognaleto["default"], {}, _crosia["default"], {}, _dragoni["default"], {}, _esinoLario["default"], {}, _filandari["default"], {}, _filignano["default"], {}, _firenze["default"], {}, _fossatoSerralta["default"], {}, _garaguso["default"], {}, _gemonaDelFriuli["default"], {}, _ghedi["default"], {}, _ghilarza["default"], {}, _gimigliano["default"], {}, _gioiaDeiMarsi["default"], {}, _graffignana["default"], {}, _grottolella["default"], {}, _gualdo["default"], {}, _guidoniaMontecelio["default"], {}, _introdacqua["default"], {}, _ionadi["default"], {}, _laurino["default"], {}, _lessona["default"], {}, _limatola["default"], {}, _limbadi["default"], {}, _livraga["default"], {}, _magnacavallo["default"], {}, _martirano["default"], {}, _masainas["default"], {}, _masserano["default"], {}, _mercogliano["default"], {}, _mompeo["default"], {}, _montagnareale["default"], {}, _monteMarenzo["default"], {}, _monteodorisio["default"], {}, _montichiari["default"], {}, _mulazzano["default"], {}, _narcao["default"], {}, _nettuno["default"], {}, _norbello["default"], {}, _ofena["default"], {}, _olginate["default"], {}, _orioLitta["default"], {}, _ospedalettoLodigiano["default"], {}, _padru["default"], {}, _pagoDelValloDiLauro["default"], {}, _parenti["default"], {}, _patti["default"], {}, _pella["default"], {}, _pescina["default"], {}, _positano["default"], {}, _premia["default"], {}, _re["default"], {}, _renon["default"], {}, _roccalumera["default"], {}, _roccamorice["default"], {}, _rofrano["default"], {}, _rombiolo["default"], {}, _sagronMis["default"], {}, _salaBiellese["default"], {}, _saleranoSulLambro["default"], {}, _sanCalogero["default"], {}, _sanGiorgioAlbanese["default"], {}, _sanGiorgioDellaRichinvelda["default"], {}, _sanMartinoSannita["default"], {}, _sanPietroInAmantea["default"], {}, _sanRoberto["default"], {}, _saponara["default"], {}, _scampitella["default"], {}, _sessanoDelMolise["default"], {}, _spinete["default"], {}, _stio["default"], {}, _tavigliano["default"], {}, _tergu["default"], {}, _torino["default"], {}, _torraca["default"], {}, _tramontiDiSopra["default"], {}, _tramontiDiSotto["default"], {}, _travesio["default"], {}, _trontano["default"], {}, _tufo["default"], {}, _turrivalignani["default"], {}, _valBrembilla["default"], {}, _valmozzola["default"], {}, _valtorta["default"], {}, _valvasoneArzene["default"], {}, _villaDelBosco["default"], {}, _villandro["default"], {}, _villapiana["default"]);

exports["default"] = _default;